import Splide from "@splidejs/splide";

function initSplideYear(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;

	root.querySelectorAll(".splide-year").forEach((el) => {
		const hasPreFormation = el.classList.contains("has-pre-formation");

		const splide = new Splide(el, {
			perPage: 3,
			gap: "25px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: 0,
			omitEnd: true,
			speed: 700,
			breakpoints: {
				1023: { perPage: 2.2, gap: "30px" },
				768: { perPage: 1.5, gap: "12px" },
				580: { perPage: 1.1, gap: "12px" },
			},
		});

		if (hasPreFormation) {
			const list = el.querySelector(".splide__list");
			const firstSlide = list.querySelector(".splide__slide:first-child");
			const clone = firstSlide ? firstSlide.cloneNode(true) : null;

			// Sur mobile, supprimer le year-before du slider avant l'init
			if (window.innerWidth <= 767 && firstSlide) {
				firstSlide.remove();
			}

			splide.mount();

			let wasMobile = window.innerWidth <= 767;

			window.addEventListener("resize", () => {
				const isMobile = window.innerWidth <= 767;
				if (isMobile === wasMobile) return;
				wasMobile = isMobile;

				if (isMobile && clone) {
					const current = list.querySelector(".splide__slide:first-child");
					if (current && current.querySelector(".card-year-before")) {
						current.remove();
						splide.refresh();
					}
				} else if (!isMobile && clone) {
					const hasYearBefore = list.querySelector(".card-year-before");
					if (!hasYearBefore) {
						list.prepend(clone.cloneNode(true));
						splide.refresh();
					}
				}
			});
		} else {
			splide.mount();
		}
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSplideYear());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-slider-years", ($block) => {
		initSplideYear($block && $block.jquery ? $block.get(0) : $block);
	});
}
